// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jL76N","col":"styles_col__1RFr8"};